import styled from 'styled-components';

export const PricingAdvanceSettingsStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-16);
  
  .pricingAdvanceSettings {
    &__body {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: var(--spacing-16);
      padding: var(--spacing-16);
      background-color: var(--color-sonata-primary-200, #F2F5FC);
      border-radius: var(--spacing-8);
      
      &--hide {
        display: none;
      }
    }

    @media (max-width: 768px) {
      &__body {
        grid-template-columns: repeat(2, 1fr);
      }
    }

    @media (max-width: 480px) {
      &__body {
        grid-template-columns: 1fr;
      }
    }
    
    &__titleToggle {  
      .checkboxText {
        color: ${props => props.theme.uiColors.textBodyDefault};
        font-family: ${props => props.theme.fontSemiBold};
        font-size: ${props => props.theme.fontSizeM};
      }
    }
  }
`;
